<template>
  <div class="app flex-row align-items-center loginbgnew">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center">
            <img
              class="mb-4"
              src="/images/brand-mark-white_1.svg"
              height="70"
              alt="ux.app Logo"
            />
          </div>
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="tryLogin">
                  <h1 v-if="loginStatus != 'success'">Login</h1>
                  <p v-if="loginStatus != 'success'" class="text-muted">
                    Sign In to your account
                  </p>
                  <div
                    v-if="loginStatus"
                    class="alert"
                    :class="{
                      'alert-warning': loginStatus == 'error',
                      'alert-success': loginStatus == 'success'
                    }"
                  >
                    <template v-if="loginStatus == 'error'">
                      <b>Login Failed!</b>
                      <br />
                      Please check your credentials!
                    </template>
                    <template v-if="loginStatus == 'success'">
                      <b>Redirecting!</b> Please wait...
                    </template>
                  </div>
                  <section v-if="loginStatus != 'success'">

                      <b-input-group class="mb-3">
                        <b-input-group-prepend
                          ><b-input-group-text
                            ><i class="icon-user"/></b-input-group-text
                        ></b-input-group-prepend>
                        <b-form-input
                          v-model="user.email"
                          type="text"
                          class="form-control"
                          placeholder="Username"
                          autocomplete="username email"
                        />
                      </b-input-group>
                      <b-input-group class="mb-4">
                        <b-input-group-prepend
                          ><b-input-group-text
                            ><i class="icon-lock"/></b-input-group-text
                        ></b-input-group-prepend>
                        <b-form-input
                          v-model="user.pass"
                          type="password"
                          class="form-control"
                          placeholder="Password"
                          autocomplete="current-password"
                        />
                      </b-input-group>
                      <b-row>
                        <b-col cols="6">
                          <b-button variant="primary" type="submit" class="px-4">
                            Login
                          </b-button>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <router-link
                            class="btn btn-link"
                            :to="{ name: 'ForgotPassword' }"
                          >
                            Forgot password?
                          </router-link>
                        </b-col>
                      </b-row>
                  </section>
                </b-form>
              </b-card-body>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => {
    return {
      redirToUrl: '',
      loginStatus: '',
      tryLoggged: false,
      user: {
        email: '',
        pass: ''
      }
    };
  },
  mounted() {
    let query = this.$route.query;
    if(query && query.redirToUrl && !query.redirToUrl.includes('login')) {
      this.redirToUrl = query.redirToUrl;
    }
    this.isLogged();
  },
  methods: {
    // ToDo: Implement ShowPass
    // showPass() {
    //   if ($(this.$refs.passField).attr('type') == 'password') {
    //     $(this.$refs.passField).attr('type', 'text');
    //   } else {
    //     $(this.$refs.passField).attr('type', 'password');
    //   }
    // },
    isLogged() {
      let $this = this;
      if (localStorage.getItem('refreshToken')) {
        this.$store
          .dispatch(
            'account/refreshToken',
            localStorage.getItem('refreshToken')
          )
          .then(response => {
            this.loginStatus = 'success';
            this.$store.dispatch('account/autoRefreshToken');
            if(this.redirToUrl) {
              this.$router.push(this.redirToUrl);
            } else {
              this.$router.push({ name: 'Dashboard' });
            }
          })
          .catch(err => {
            console.error(err);
            localStorage.removeItem('refreshToken');
            this.tryLoggged = true;
          });
      } else {
        this.tryLoggged = true;
      }
    },
    tryLogin() {
      this.$http
        .post('/api/auth/login', {
          UserName: this.user.email,
          Password: this.user.pass
        })
        .then(resp => {
          if (resp.data.jwtToken) {
            this.loginStatus = 'success';
            this.$store.commit('account/setUserData', {
              auth_token: resp.data.jwtToken,
              user: resp.data,
              refreshToken: resp.data.refreshToken,
              env: resp.data.env
            });
            localStorage.setItem('refreshToken', resp.data.refreshToken);
            this.$store.dispatch('account/autoRefreshToken');
            setTimeout(() => {
              this.$router.push({ name: 'Dashboard' });
            }, 1000);
          } else {
            localStorage.removeItem('refreshToken');
            this.loginStatus = 'error';
          }
        })
        .catch(error => {
          //console.info('tryLogin', error.response)
          localStorage.removeItem('refreshToken');
          this.loginStatus = 'error';
        });
    }
  }
};
</script>
